'use client';

import { useLocale } from '@/i18n/context';
import type { Locale } from '@/i18n/types';
import { useTranslations } from '@/i18n/client';

export function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();
  const { t } = useTranslations();
  const nav = t('nav');

  const locales: { value: Locale; label: string; ariaLabel: string }[] = [
    { value: 'es', label: 'ES', ariaLabel: nav.changeLangEs || 'Cambiar idioma a español' },
    { value: 'en', label: 'EN', ariaLabel: nav.changeLangEn || 'Switch language to English' },
  ];

  return (
    <div className="hidden sm:flex items-center gap-1 font-mono text-[10px] tracking-[0.14em]">
      {locales.map((l, i) => (
        <span key={l.value} className="flex items-center gap-1">
          {i > 0 && <span className="opacity-30">/</span>}
          <button
            onClick={() => setLocale(l.value)}
            aria-label={l.ariaLabel}
            aria-pressed={locale === l.value}
            className="cursor-pointer bg-transparent border-0 p-0 font-mono text-[10px] tracking-[0.14em]"
            style={{
              color: locale === l.value
                ? 'var(--color-ink)'
                : 'var(--color-mute)',
            }}
          >
            {l.label}
          </button>
        </span>
      ))}
    </div>
  );
}
